import * as React from 'react';

import { Link } from 'react-router-dom';
import { AuthLayout } from '../layouts/AuthLayout';
import { useTitle } from '../useTitle';
import { useAuth } from '../contexts/AuthContext';
import { ButtonLink } from '../components/Button';
import { paths } from '../paths';

export const NotFound: React.FC = () => {
  return (
    <AuthLayout>
      <NotFoundContent />
    </AuthLayout>
  );
};

export const NotFoundContent: React.FC = () => {
  useTitle('Page not found');
  const { user, logout } = useAuth();

  return (
    <div className="space-y-6">
      <h1 className="text-center text-2xl">404 not found 🤷‍♂️</h1>
      <p className="text-center">
        The page you're looking for doesn't exist or you may need to{' '}
        {user ? (
          <span>
            <Link
              to={paths.signIn()}
              onClick={logout}
              className="text-primary"
              title="Sign out so you can sign in as a different user"
            >
              sign in as a different user
            </Link>
          </span>
        ) : (
          <Link
            to={paths.signIn()}
            className="text-primary"
            title="Sign out so you can sign in as a different user"
          >
            sign in
          </Link>
        )}
        .
      </p>
      {user ? (
        <ButtonLink to="/" className="max-w-sm mx-auto">
          Back to Home
        </ButtonLink>
      ) : null}
    </div>
  );
};
